import React from "react";
import Modal from "react-bootstrap/Modal";
import ContactModal from "../ContactModal/ContactModal";
import "./style.css";

const InactivityModal = ({ showModal, handleContinue }) => {
  return (
    <Modal className="cust" show={showModal}>
      <Modal.Header closeButton onHide={handleContinue}>
        <Modal.Title>leave your info and get one class for free</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ContactModal
          title="we'll get back shortly"
          name="name*"
          phone="phone (WhatsApp)*"
          email="kid's age"
          type="number"
        />
      </Modal.Body>
    </Modal>
  );
};

export default InactivityModal;
